import React from 'react';
import { withStyles } from 'material-ui/styles';
import {withRouter} from "react-router-dom";
import UIComponent from '../core/ui/ui_component.js';
import UIButton from '../core/ui/button.js';
import UIIcon from '../core/ui/icon.js';
import SearchResults from './search_results.js';
import Grid from 'material-ui/Grid';
import Survey from './components/survey.js';

const styles = theme => ({
  results: {
    marginTop: 10,
    paddingLeft: 16,
    paddingRight: 16,
    marginBottom: 20,
  },
  div1: {
    height: '20px',
  },
  stats: {
    textAlign: 'right',
    fontSize: 8,
    color: '#808080',
    float: 'right',
  },
  debugMode: {
    float: 'left',
    fontSize: 8,
    color: '#808080',
  },    
  related: {
    fontSize: 14,
    lineHeight: '20px',
    color: '#808080',
    marginBottom: 10,
  },  
  more: {
    textAlign: 'center',
    fontSize: 10,
    color: '#808080',
    marginBottom: 10,
  },  
  didYouMean : {
    marginTop: 10,
  },
  debugIcon : {
    position: 'fixed',
    right: 0,
    top: 0,
    padding: 2,
    margin: 3,
    borderRadius: '15px',
    border: '2px solid red',
    backgroundColor: 'white',
  },
  related: {
    paddingRight: 5,
  }
});

class Search extends UIComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loadingMore: false,
    };

    this.triggerOnLoadMore = this.triggerOnLoadMore.bind(this);
  }

  triggerOnLoadMore(){
    const $this = this;
    this.setState({loadingMore : true}, function(){
      if($this.props.onLoadMore){
        $this.props.onLoadMore(function(){
          $this.setState({loadingMore : false});
        });
      }
    });
  }

  render(){
    const classes = this.props.classes;
    return (      
      this.props.results &&
      <Grid container>
        <Grid item hidden={{xsDown : true}} sm={1}>
        </Grid>
        <Grid item xs={12} sm={10}>
          <Survey api={window.__api}/>
          {this.props.devMode &&
            <UIIcon icon={'debug'} className={classes.debugIcon}/>
          }
          <div className={classes.results}>
            {this.renderResults()}
          </div>
        </Grid>
        <Grid item hidden={{xsDown : true}} sm={1}>
        </Grid>
      </Grid>
    );    
  }

  renderResults(){
    const classes = this.props.classes;
    const related1 = (this.props.results && this.props.results.related) ? this.props.results.related.slice(0,5) : null;
    const related2 = (this.props.results && this.props.results.related) ? this.props.results.related.slice(5,10) : null;
    var key = 0;
    return (
        <div>
          <Grid item xs={12} className={classes.div1}>
            <div className={classes.debugMode}>
              Powered by <a href="https://cse.google.com/cse">Google Custom Search</a>
            </div>
            <div className={classes.stats}>
              About {this.props.results.searchInformation.formattedTotalResults} results ({this.props.results.searchInformation.formattedSearchTime} secs)
            </div>
          </Grid>
          {this.props.results.spelling &&
            <Grid item xs={12} className={classes.didYouMean}>
              <a href={`./#/?q=${encodeURIComponent(this.props.results.spelling.correctedQuery)}`}>Did you mean: {this.props.results.spelling.correctedQuery}?</a>
            </Grid>
          }
          <Grid item xs={12}>
            <SearchResults type='div' results={this.props.results} uiOptions={this.props.uiOptions} devMode={this.props.devMode} server={this.props.server}/>
          </Grid>
          {this.props.results.related && this.props.results.related.length > 0 && 
            <Grid item xs={12} className={classes.related}>
              <h3>Related Searches</h3>
              <Grid container spacing={0}>
                <Grid item xs={12} sm={6} className={classes.related}>
                  {related1.map(related =>
                    <div key={key++}><a href={`./#/?q=${encodeURIComponent(related)}`}>{related}</a></div>
                  )}             
                </Grid>
                <Grid item xs={12} sm={6} className={classes.related}>
                  {related2.map(related =>
                    <div key={key++}><a href={`./#/?q=${encodeURIComponent(related)}`}>{related}</a></div>
                  )}             
                </Grid>
              </Grid>
            </Grid>
          }
          <Grid item xs={12} className={classes.more}>
          {this.props.results.queries.nextPage ?
            <UIButton color={'primary'} disabled={this.state.loadingMore} onClick={this.triggerOnLoadMore}>More</UIButton>
          :
            <UIButton color={'primary'} disabled={true}>No more results</UIButton> 
          }
          </Grid>            
        </div>
    );
  }

}

withRouter(Search);
export default withStyles(styles)(Search);





// WEBPACK FOOTER //
// ./src/search/search.js